import script from "./StaxGuestPay.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaxGuestPay.vue?vue&type=script&setup=true&lang=ts"

import "./StaxGuestPay.vue?vue&type=style&index=0&id=8e688084&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e688084"]])

export default __exports__